import * as n from "@sentry/vue";
import { nanoid as u } from "nanoid";
function o(e) {
  try {
    const [, r] = /\n *dsn *= *(.+) */i.exec(e) || [];
    return r && r.length > 0 ? r.trim() : void 0;
  } catch {
    return;
  }
}
const s = [
  "localhost",
  // Numberly env
  "numberly.dev",
  "numberly.st",
  "numberly.in",
  "numberly.com",
  // Google and ReCAPTCHA
  "google.com",
  "gstatic.com"
];
function l(e) {
  const r = {};
  return e.browserTracingConfiguration ? new n.BrowserTracing({
    ...e.browserTracingConfiguration
  }) : (e.vueRouter && (r.routingInstrumentation = n.vueRouterInstrumentation(
    e.vueRouter
  )), r.shouldCreateSpanForRequest = (c) => ![...s, ...e.blockedTracingOrigins ?? []].some((i) => c.includes(i)), new n.BrowserTracing(r));
}
function g(e) {
  return e.replayConfiguration ? new n.Replay({ ...e.replayConfiguration }) : new n.Replay();
}
var a = /* @__PURE__ */ ((e) => (e.Development = "development", e.Staging = "staging", e.Production = "production", e))(a || {});
const m = {
  [a.Development]: 1,
  // By default, send 100% of transactions & replays to Sentry.
  [a.Staging]: 1,
  // By default, send ~2.5% of transactions & replays to Sentry.
  [a.Production]: 0.025
};
function f(e) {
  const r = m[e.projectEnv || a.Development];
  if (!e.dsn && !e.sentryclirc)
    throw new Error('vue-sentry module requires "dsn" or "sentryclirc" option.');
  const c = e.dsn || o(e.sentryclirc || "");
  if (!c)
    throw new Error("Sentry DSN not configured, please accept the merge request.");
  const t = {
    ...e,
    dsn: c,
    environment: e.projectEnv,
    release: `${e.projectName}@${e.projectVersion || "0.0.0"}`,
    tracesSampleRate: e.forceSampleRate || r,
    replaysSessionSampleRate: e.forceSampleRate || r,
    // Capture 100% of replay for sessions with errors.
    replaysOnErrorSampleRate: 1
  }, i = [l(e)];
  e.app && (t.app = e.app), e.Vue && (t.Vue = e.Vue), e.enableSentryReplay && i.push(g(e)), t.integrations = [...i], n.init(t), n.setUser({ id: u() });
}
export {
  a as SentryEnvironment,
  o as extractSentryDsn,
  f as initSentry
};
